import { render, staticRenderFns } from "./recommendFood.vue?vue&type=template&id=65bb899f&scoped=true"
import script from "./recommendFood.vue?vue&type=script&lang=js"
export * from "./recommendFood.vue?vue&type=script&lang=js"
import style0 from "./recommendFood.vue?vue&type=style&index=0&id=65bb899f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb899f",
  null
  
)

export default component.exports